/* global axios */
let base = window._env_.VUE_APP_ORDER_AUDIT_API_HOST

export const getInternAttendancePlanApi = params => {
  return axios.get(`${base}/admin/intern-attendance-plan/month`, { params })
}

export const saveInternAttendancePlanApi = params => {
  return axios.post(`${base}/admin/intern-attendance-plan/save`, params)
}

export const clearInternAttendancePlanApi = params => {
  return axios.post(`${base}/admin/intern-attendance-plan/clear`, params)
}

export const queryInternAttendancePlanMonthlyApi = params => {
  return axios.post(`${base}/admin/intern-attendance-plan/query_list`, params)
}

export const queryInternAttendancePlanDetailApi = params => {
  return axios.post(`${base}/admin/intern-attendance-plan/query_detail`, params)
}

export const getInternAttendancePlanMonthlyDetailApi = params => {
  return axios.get(`${base}/admin/intern-attendance-plan/detail`, { params })
}



// WEBPACK FOOTER //
// ./src/views/workbench/workbench.api.js